import * as React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectAuth } from "../../store/auth_slice";
import ProfileCard from "../../common/profile_card/profile_card";
import Button from "../../common/button/button";
// import CustomCard from "../../common/custom_card/custom_card";
import DetailCards from "../../common/details_card/details_card";
import Header from "../../common/header/header";
import Footer from "../../common/footer/footer";
import SkeletonLoader from "../../common/skeleton/skeleton_loader";

const MyAccount: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const { user } = useSelector(selectAuth);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <SkeletonLoader type="account" />;
  }

  if (!user) {
    return (
      <div className="min-h-screen flex flex-col">
        <div className="flex-grow w-full flex justify-center">
          <div className="w-full max-w-7xl p-4">
            <Header />
            <div className="py-20">
              <h1 className="text-3xl font-bold mb-6">Please log in to view your account</h1>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-grow w-full flex justify-center">
        <div className="w-full max-w-7xl p-4">
          <Header />
          <div className="py-20">
            <h1 className="text-3xl font-bold mb-6">My Account</h1>
            <div className="flex flex-col md:flex-row gap-6">
              <div className="md:w-1/3 space-y-4">
                <ProfileCard
                  name={`${user.firstName} ${user.lastName}`}
                  memberSince={user.creationYear}
                  location="Romania"
                />
                <Button
                  buttonType="transparent"
                  className="w-full text-left"
                  onClick={() => {}}
                >
                  Change password
                </Button>
                <Button
                  buttonType="transparent"
                  className="w-full text-left"
                  onClick={() => {}}
                >
                  Deactivate account
                </Button>
                {/* <CustomCard
                  imageSrc="/path-to-custom-icon.png"
                  imageAlt="Custom Icon"
                  buttonText="Go to my messages"
                  backgroundColor="bg-bluePrimary"
                  onClick={() => {}}
                /> */}
              </div>
              <div className="md:w-2/3">
                <DetailCards />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MyAccount;
